import React, { Component } from 'react'
import Chart from './Chart'

class DataChart extends Component {

  constructor(props){
    super(props)
    this.chartKey = 0
  }

  shouldComponentUpdate(nextProps, nextState){
    return (this.props.history.length != nextProps.history.length)
  }

  render(){
    this.chartKey++
    if(this.props.history && this.props.history.length > 0){
      return (
        <Chart key={this.chartKey} history={this.props.history}/>
      )
    }
    return null
  }
}

export default DataChart
